import React from 'react';
import SVGIcon from './svg_icon';

type IconButtonProps = {
  IconComponent: React.ComponentType;
  onClick: () => void;
  bgColor?: string; 
  textColor?: string; 
};

const IconButton: React.FC<IconButtonProps> = ({ 
  IconComponent, 
  onClick,
  bgColor = "bg-sky-700", 
  textColor = "text-white" 
}) => {
  return (
    <div className="relative py-2">
      <button 
        onClick={onClick}
        className={`${bgColor} ${textColor} rounded-full p-2 h-20 w-20 flex items-center justify-center`}
      >
        <SVGIcon IconComponent={IconComponent} />
      </button>
    </div>
  );
};

export default IconButton;
